import axios from 'axios';

export const snelstartService = {
  async getStatus() {
    const response = await axios.get('/integrations/snelstart/status');
    return response.data;
  },

  async connect(payload) {
    const response = await axios.post('/integrations/snelstart/connect', payload);
    return response.data;
  },

  async update(payload) {
    const response = await axios.patch('/integrations/snelstart', payload);
    return response.data;
  },

  async disconnect() {
    const response = await axios.delete('/integrations/snelstart');
    return response.data;
  },

  async listGrootboekrekeningen() {
    const response = await axios.get('/integrations/snelstart/grootboekrekeningen');
    return response.data;
  },
};

export default snelstartService;
